package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class PushPlatform {
    ANDROID,
    IOS,
    WEB,
}

@Serializable
data class PushTokenRequest(
    val token: String,
    val platform: PushPlatform,
    val deviceName: String? = null,
)
